document.addEventListener('DOMContentLoaded', () => {
  const cards = document.querySelectorAll('.product-card');

  const observer = new IntersectionObserver((entries) => {
    entries.forEach((entry) => {
      if (entry.isIntersecting) {
        entry.target.classList.add('scroll-visible');
        observer.unobserve(entry.target);
      }
    });
  }, {
    threshold: 0.15
  });

  cards.forEach((card, index) => {
    card.style.transitionDelay = `${(index % 4) * 0.12}s`;
    observer.observe(card);
  });
});